import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import {
  EnrichmentData,
  States
} from '../../../features/PpiContainer/constants';
import { getPpiById } from '../../../features/PpiContainer/selectors';
import { ppiPublishedRoute, ppiInProgressRoute } from '../../../routes';
import DataTypes from '../../Table/dataTypes';
import Table from '../../Table/Table';
import FormContext from '../../Form/FormContext';
import UpdatesIcon from '../../common/UpdatesIcon';

function getEnrichmentData(ppsi, enrichmentData) {
  const { id: ppiId } = ppsi;
  return { ppiId, ...enrichmentData };
}

function getPpiVersions(ppi) {
  const data = [];
  if (ppi[EnrichmentData.IN_PROGRESS]) {
    data.push(getEnrichmentData(ppi, ppi[EnrichmentData.IN_PROGRESS]));
  }
  if (ppi[EnrichmentData.PUBLISHED]) {
    data.push(getEnrichmentData(ppi, ppi[EnrichmentData.PUBLISHED]));
  }
  return data;
}

const VersionColumns = {
  PresentationName: {
    name: 'presentationName',
    label: 'Product Name',
    dataField: 'presentationName',
    translatable: true,
    link: rowData => {
      return rowData.enrichmentStatus === States.PUBLISHED ||
        rowData.enrichmentStatus === States.UNPUBLISHED
        ? ppiPublishedRoute(rowData.ppiId)
        : ppiInProgressRoute(rowData.ppiId);
    }
  },
  Status: {
    name: 'status',
    dataField: 'enrichmentStatus',
    label: 'Status',
    width: 100
  },
  Version: {
    name: 'version',
    dataField: 'version',
    label: 'Version',
    width: 50,
    grow: 0,
    shrink: 0
  },
  VersionComment: {
    name: 'versionComment',
    label: 'Version Comment',
    dataField: 'versionComment',
    translatable: true
  },
  ActualPublishDate: {
    name: 'actualPublishDate',
    dataField: `actualPublishedDate`,
    dataType: DataTypes.Date,
    label: 'Publishing Date',
    searchable: false,
    width: 150,
    grow: 0,
    shrink: 0
  },
  Updates: {
    name: 'updates',
    CellValue: ({ rowData }) => {
      const { upToDate, updateNotificationList } = rowData.data;
      return (
        !upToDate && (
          <UpdatesIcon
            rowData={rowData}
            message={updateNotificationList
              .map(notification => notification.message)
              .join(',')}
          />
        )
      );
    },
    label: 'Updates',
    width: 100,
    grow: 0,
    shrink: 0
  }
};
const VersionsTabContent = () => {
  const { data } = useContext(FormContext);
  const { ppiId } = data;
  const ppi = useSelector(getPpiById(ppiId)).toJS();
  const versions = getPpiVersions(ppi);

  return (
    <div style={{ height: '400px' }}>
      <Table
        title="ppsi.versionsTableHeader"
        data={versions}
        columns={[
          VersionColumns.PresentationName,
          VersionColumns.Status,
          VersionColumns.Version,
          VersionColumns.VersionComment,
          VersionColumns.ActualPublishDate,
          VersionColumns.Updates
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'version', direction: 'asc' }]}
        selectable={false}
        toolbarVisible={false}
      />
    </div>
  );
};

export default VersionsTabContent;
